<template>
    <div class="flex flex-wrap gap-2">
        <label
            v-for="day in days"
            :key="day.value"
            class="flex items-center gap-1.5 cursor-pointer select-none"
        >
            <custom-checkbox
                :value="day.value"
                :checked="value.includes(day.value)"
                @change="toggle(day.value)"
            />
            <span class="text-sm text-theme-base">{{ day.label }}</span>
        </label>
    </div>
</template>

<script>
import { weekdayItems } from "@/common/fields/weekdays";

export default {
    name: "WeekdaySelector",
    model: {
        prop: "value",
        event: "change"
    },
    props: {
        value: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        days: weekdayItems
    }),
    methods: {
        toggle(dayValue) {
            const current = [...this.value];
            const idx = current.indexOf(dayValue);
            if (idx === -1) {
                current.push(dayValue);
                current.sort((a, b) => a - b);
            } else {
                current.splice(idx, 1);
            }
            this.$emit("change", current);
        }
    }
};
</script>
